import React from "react";

export const IconVideo = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.8"
            height="15.8"
            viewBox="0 0 21.8 15.8"
        >
            <path
                id="video"
                d="M15.6,11.6,22,7V17l-6.4-4.5v-.9ZM4,5h9a2,2,0,0,1,2,2V17a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V7A2.006,2.006,0,0,1,4,5Z"
                transform="translate(-1.1 -4.1)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="square"
                strokeWidth="1.8"
            />
        </svg>
    );
};
